import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import GridItem from 'components/Grid/GridItem';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const options = [
  { value: 'Shopify', label: 'Shopify' },
  { value: 'StockX', label: 'StockX' }
];

export default class publishComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product_list: this.props.product_ids,
      market_place: []
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = event => {
    var child = document.getElementsByTagName('h6')[0];
    child.classList.remove('h6ClassToShow');
    let value =
      event && event.length > 0 && event.map(item => item.value);
    if (value) {
      this.setState({ market_place: value });
    } else {
      this.setState({ market_place: [] });
    }
  };

  handleSubmit = () => {
    // console.log(Object.keys(this.state).length)
    if (
      this.state.market_place &&
      this.state.market_place.length > 0
    ) {
      this.props.handlePublish(this.state);
    } else {
      // to show the error message inside popup
      var para = document.getElementsByTagName('h6')[0];
      para.className += ' h6ClassToShow';
    }
  };

  render() {
    return (
      <>
        <SweetAlert
          style={{ display: 'block', marginTop: '-150px' }}
          title="Publish Products"
          onConfirm={() => this.handleSubmit()}
          onCancel={() => this.props.hideAlert()}
          confirmBtnText="Submit"
          cancelBtnText="Cancel"
          showCancel
        >
          <GridItem xs={12} sm={12} md={12} id="gridSweetId">
            <h6 className="errorH6">
              Please provide input for all fields
            </h6>
            <div className="row">
              <table className="col-md-12" cellspacing="5">
                <tr>
                  <td>Market Place</td>
                  <td>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      onChange={this.handleInputChange}
                      isMulti
                      options={options}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </GridItem>
        </SweetAlert>
      </>
    );
  }
}
